import { render, staticRenderFns } from "./BodyCostsAnalysis.vue?vue&type=template&id=7d50fd72&scoped=true"
import script from "./BodyCostsAnalysis.vue?vue&type=script&lang=js"
export * from "./BodyCostsAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodyCostsAnalysis.vue?vue&type=style&index=0&id=7d50fd72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d50fd72",
  null
  
)

export default component.exports